var exports = {
  "k": "x04b3a21e--532b3f--container",
};

module.exports = exports;
